const myCustomSlider = document.querySelectorAll(".Gallery");
const myCustomGalleryThumbs = document.querySelectorAll(".Preview");

for (let i = 0; i < myCustomSlider.length; i++) {
  myCustomSlider[i].classList.add("Gallery-" + i);
  myCustomGalleryThumbs[i].classList.add("Preview-" + i);

  const galleryThumbs = new Swiper(".Preview-" + i, {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,

  });

  const galleryTop = new Swiper(".Gallery-" + i, {
    loop: true,
    speed: 500,
    effect: 'fade',
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });
}


var swiper = new Swiper(".Review", {
  effect: "coverflow",
  grabCursor: true,
  initialSlide: 1,
  opacity: 0.5,
  centeredSlides: true,
  slidesPerView: 1,
  slidesPerView: "auto",
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 300,
    modifier: 1,
    slideShadows: false,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true },
    navigation: {

        nextEl: ".swiper-button-next-review",
        prevEl: ".swiper-button-prev-review",
    },
});




var swiper = new Swiper(".Hero", {
  loop: true,
  speed: 500,
  effect: 'fade',
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true }
});


var swiper = new Swiper(".Buy", {
  loop: true,
  speed: 500,
  effect: 'fade',
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true }
});



var accordions = document.querySelectorAll('input[type="checkbox"]');

for (var i = 0; i < accordions.length; i++) {
  accordions[i].addEventListener('change', function() {
    if (this.checked) {
      for (var j = 0; j < accordions.length; j++) {
        if (accordions[j] !== this) {
          accordions[j].checked = false;
        }
      }
    }
  });
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});


